angular.module("common").directive('pageFooter', function () {
    return {
        restrict: 'E',
        replace: 'true',
        template: '<div ng-show="VersionInfo" class="row page-footer__text" data-ng-controller="FooterController"><hr/>{{VersionInfo.Product}} v.{{VersionInfo.Version}} ' +
            '<br/>&copy; {{VersionInfo.Year}} {{VersionInfo.Company}}.<br/>All rights reserved.</div>'
    }
});